import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getStoredValue } from "../_helpers/storagehelper";

const initialFacilityData = {
  FacilityID: 0,
  //facility search
  exportExcel: false,
  exportPDF: false,
  //prepopulate
  PrePopulate: false,

  //facility information
  FacilityCode: "",
  FacilityName: "",
  Email: "",
  Address1: "",
  Address2: "",
  City: "",
  ZIP: "",
  LogoFilePath: "",
  LogoFile: "",
  folderPath: "",
  filename: "",
  file: "",
  base64Data: "",
  StateNameID: 0,
  PhoneNumber: "",
  IsQuarantineWordBlock: 0,
  ActiveStatus: 1,
  logoImage: {
    name: "empty",
    type: "image/jpeg",
    size: 5 * 1024 * 1024,
  },

  //accessible permission
  IsMessageAcess: 0,
  IsMailScanningAccess: 0,
  IsReview: 0,
  IsDocumentsAccess: 0,
  IsPhotoAccess: 0,
  IsEcardAccess: 0,
  IsFormReqAccess: 0,
  IsEmojiEnabled: 0,
  IsLawLibraryAccess: 0,
  IsCommissaryAccess: 0,
  IsInmateInvitePublic: 0,
  IsInmateFreeCredit: 0,
  DisplayCurrentDate: 0,
  IsInmateCactasCredit: 0,
  IsApprovalRequiredForConnectionRequest: 0,
  IsPurchaseDisabled: 0,
  InmateUploadType: 1,

  //web service
  isValidateWebService: 0,
  CactasURL: "",
  CactasAccessKey: "",

  //FTP
  FTPServerURL: "",
  FTPUserName: "",
  FTPPassword: "",
  FTPFilePath: "",

  //FinancialSetup
  FacilityMessageCost: "",
  FacilityPhotoCost: "",
  FacilityEmojiCost: "",
  FacilityEcardCost: "",
  FacilityAudioVideoCost: "",
  FacilityAudioCost: "",

  //SecuritySetup
  IsSQ: 0,
  IsKS: 0,

  //Connection Request Setup
  InmateInvitePublicFrequencyType: 0,
  InmateInvitePublicCount: "",
  InmateInvitePublicRepeatLimit: "",
  InmateInvitePublicActiveStatus: 1,

  //free credit
  InmateFreeCreditFrequencyType: 0,
  InmateFreeCreditAmount: 0,
  FreeCreditActiveStatus: 1,

  //allowable URL's
  Type_CommissaryAccessInterval: [
    {
      AccessFromTime: "",
      AccessToTime: "",
      FacilityID: 0,
      KioskCommissaryAccessID: 0,
      WeekDayNumber: 2,
      isEnable: false,
    },
    {
      AccessFromTime: "",
      AccessToTime: "",
      FacilityID: 0,
      KioskCommissaryAccessID: 0,
      WeekDayNumber: 3,
      isEnable: false,
    },
    {
      AccessFromTime: "",
      AccessToTime: "",
      FacilityID: 0,
      KioskCommissaryAccessID: 0,
      WeekDayNumber: 4,
      isEnable: false,
    },
    {
      AccessFromTime: "",
      AccessToTime: "",
      FacilityID: 0,
      KioskCommissaryAccessID: 0,
      WeekDayNumber: 5,
      isEnable: false,
    },
    {
      AccessFromTime: "",
      AccessToTime: "",
      FacilityID: 0,
      KioskCommissaryAccessID: 0,
      WeekDayNumber: 6,
      isEnable: false,
    },
    {
      AccessFromTime: "",
      AccessToTime: "",
      FacilityID: 0,
      KioskCommissaryAccessID: 0,
      WeekDayNumber: 7,
      isEnable: false,
    },
    {
      AccessFromTime: "",
      AccessToTime: "",
      FacilityID: 0,
      KioskCommissaryAccessID: 0,
      WeekDayNumber: 1,
      isEnable: false,
    },
  ],
  LawLibraryLink: "",
  CommissaryAccessLink: "",

  //Forms
  Type_RequestFormPermission: [],
  Type_RequestMGUserFormPermission: [],

  //lock KIOSK
  Type_KioskRestrictInterval: [],

  error: null,
  loading: false,
  createdBy: getStoredValue("user")
    ? getStoredValue("user").ManagementUserID
    : "",
};

const facilitySearch = {
  facilityCode: "",
  facilityName: "",
  city: "",
  activeStatus: 2,
  stateNameID: 0,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy: "FacilityCode asc", //asc desc
  exportExcel: false,
  exportPDF: false,
};

const initialDaysListData = {
  sunday: [],
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sundayCheckbox: false,
  mondayCheckbox: false,
  tuesdayCheckbox: false,
  wednesdayCheckbox: false,
  thursdayCheckbox: false,
  fridayCheckbox: false,
  saturdayCheckbox: false,
  sundayDeleteChk: [],
  mondayDeleteChk: [],
  tuesdayDeleteChk: [],
  wednesdayDeleteChk: [],
  thursdayDeleteChk: [],
  fridayDeleteChk: [],
  saturdayDeleteChk: [],
};

const intialFormsDetails = {
  isManagementSelectAll: false,
  isInmateSelectAll: false,
  inmateRequestForm: [],
  checkInmateRequestForm: [],
  managementRequestForm: [],
  checkManagementRequestForm: [],
};

// create slice
const name = "facility";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const facilityAction = { ...slice.actions, ...extraActions };
export const facilityReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    facilityData: initialFacilityData,
    facilitySearchData: facilitySearch,
    facilityList: {}, //for Create
    facilityDetails: {}, //for Edit
    addFacilityResponse: {
      loading: false,
      IsSucceed: null,
    },
    facilityPCRDetails: {},
    InmateForm: [],
    ManagementForm: [],
    loading: false,
    DaysListData: initialDaysListData,
    FormsDetails: intialFormsDetails,
    initialFacilityData: initialFacilityData,
  };
}

function createReducers() {
  return {
    setFacilityData,
    resetForm,
    resetFacilityFormResponse,
    disableWebServiceValidation,
    setFacilitySearch,
    resetFacilitySearch,
    setDaysListData,
    resetDaysListData,
    setManagementForm,
    setInmateForm,
    setFormsDetails,
  };

  function resetForm(state) {
    state.facilityData = initialFacilityData;
    state.addFacilityResponse.IsSucceed = 3;
  }

  function resetFacilityFormResponse(state) {
    state.addFacilityResponse.IsSucceed = 10;
  }

  function setFacilityData(state, action) {
    state.facilityData = action.payload && action.payload;
  }

  function disableWebServiceValidation(state, action) {
    state.facilityData["isValidateWebService"] = 0;
  }

  function setFacilitySearch(state, action) {
    state.facilitySearchData = action.payload && action.payload;
  }

  function resetFacilitySearch(state) {
    state.facilitySearchData = { ...facilitySearch };
  }

  function setDaysListData(state, action) {
    state.DaysListData = action.payload && action.payload;
  }
  function resetDaysListData(state) {
    state.DaysListData = initialDaysListData;
  }
  function setInmateForm(state, action) {
    state.InmateForm = action.payload && action.payload;
  }
  function setManagementForm(state, action) {
    state.ManagementForm = action.payload && action.payload;
  }
  function setFormsDetails(state, action) {
    state.FormsDetails = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser`;
  return {
    addFacility: addFacility(),
    updateFacility: updateFacility(),
    getFacilityList: getFacilityList(),
    GetFacilityDetailsByID: GetFacilityDetailsByID(),
    GetFacilityStaffReqInfo: GetFacilityStaffReqInfo(),
    getPCRDetails: getPCRDetails(),
    getInmateRequestForm: getInmateRequestForm(),
    getManagementRequestForm: getManagementRequestForm(),
  };

  function addFacility() {
    return createAsyncThunk(
      `${name}/addFacility`,
      async (facilityData) =>
        await fetchWrapper.post(
          `${baseUrl}/Facility/CreateFacility`,
          facilityData
        )
    );
  }

  /*   update facility */
  function updateFacility() {
    return createAsyncThunk(
      `${name}/UpdateFacility`,
      async (facilityData) =>
        await fetchWrapper.post(
          `${baseUrl}/Facility/UpdateFacility`,
          facilityData
        )
    );
  }

  /* Facility  list with search */
  function getFacilityList() {
    return createAsyncThunk(`${name}/FacilityList`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Facility/LoadFacilityList`,
        data
      );
    });
  }

  /* PCR Details for Modal */
  function getPCRDetails() {
    return createAsyncThunk(`${name}/PCRDetails`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Facility/LoadFacilityBasedPCRequestAccessedInmateList`,
        data
      );
    });
  }

  /* Inmate Request form */
  function getInmateRequestForm() {
    return createAsyncThunk(`${name}/InmateForm`, async () => {
      return await fetchWrapper.get(
        `${baseUrl}/Facility/GetRequestFormTypeList`
      );
    });
  }

  /* Management request form */
  function getManagementRequestForm() {
    return createAsyncThunk(`${name}/ManagementForm`, async () => {
      return await fetchWrapper.post(
        `${baseUrl}/Facility/GetManagementUserRequestFormTypeList`
      );
    });
  }

  //edit facility details
  function GetFacilityDetailsByID() {
    return createAsyncThunk(`${name}/GetFacilityInfo`, async (data) => {
      return await fetchWrapper.get(
        `${baseUrl}/Facility/GetFacilityInfo?facilityID=${data?.facilityID}`
      );
    });
  }

  /* facility details for staff request form */

  function GetFacilityStaffReqInfo() {
    return createAsyncThunk(`${name}/GetFacilityStaffReqInfo`, async (data) => {
      return await fetchWrapper.get(
        `${baseUrl}/Facility/GetFacilityStaffReqInfo?facilityID=${data?.facilityID}`
      );
    });
  }
}

function createExtraReducers(builder) {
  builder
    //create facility
    .addCase(extraActions.addFacility.pending, (state) => {
      state.addFacilityResponse.loading = true;
      state.error = null;
    })
    .addCase(extraActions.addFacility.fulfilled, (state, action) => {
      state.addFacilityResponse.loading = false;
      state.addFacilityResponse.IsSucceed = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.addFacility.rejected, (state, action) => {
      state.addFacilityResponse.loading = false;
      state.error = action.error.message || "Failed to add facility";
    })

    //Update Facility Details
    .addCase(extraActions.updateFacility.pending, (state) => {
      state.addFacilityResponse.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateFacility.fulfilled, (state, action) => {
      state.addFacilityResponse.IsSucceed = action?.payload;
      state.addFacilityResponse.loading = false;
      state.error = null;
    })
    .addCase(extraActions.updateFacility.rejected, (state, action) => {
      state.error = action.error.message || "Failed to Edit facility";
      state.addFacilityResponse.loading = false;
    })

    //Get Facility Details
    .addCase(extraActions.GetFacilityDetailsByID.pending, (state) => {
      state.facilityDetails.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetFacilityDetailsByID.fulfilled, (state, action) => {
      state.facilityDetails = action?.payload;
      state.facilityDetails.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetFacilityDetailsByID.rejected, (state, action) => {
      state.error = action.error.message || "Failed to Edit facility";
      state.facilityDetails.loading = false;
    })

    //GetFacilityStaffReqInfo
    .addCase(extraActions.GetFacilityStaffReqInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetFacilityStaffReqInfo.fulfilled,
      (state, action) => {
        state.GetFacilityStaffReqInfoResponse = action?.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(extraActions.GetFacilityStaffReqInfo.rejected, (state, action) => {
      state.error = action.error.message || "Failed to Edit facility";
      state.loading = false;
    })

    //facility list
    .addCase(extraActions.getFacilityList.pending, (state, action) => {
      state.facilityList.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getFacilityList.fulfilled, (state, action) => {
      const params = action.meta.arg;
      if (params?.exportExcel) {
        state.facilityFullData = action?.payload;
      } else {
        state.facilityList = action.payload;
      }
      state.facilityList.loading = false;
      state.error = null;
    })
    .addCase(extraActions.getFacilityList.rejected, (state, action) => {
      state.facilityList.loading = false;
      state.error = action.error.message || "Failed to get facility list";
    })

    //facility PCR Details
    .addCase(extraActions.getPCRDetails.pending, (state, action) => {
      state.facilityPCRDetails.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getPCRDetails.fulfilled, (state, action) => {
      const params = action.meta.arg;
      if (!params?.exportExcel) {
        state.facilityPCRDetails = action.payload;
      }
      state.facilityPCRDetails.loading = false;
      state.error = null;
    })
    .addCase(extraActions.getPCRDetails.rejected, (state, action) => {
      state.facilityPCRDetails.loading = false;
      state.error = action.error.message || "Failed to get PCR details";
    })

    //inmate form
    .addCase(extraActions.getInmateRequestForm.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getInmateRequestForm.fulfilled, (state, action) => {
      state.InmateForm = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.getInmateRequestForm.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get Inmate Request form";
    })
    //management form
    .addCase(extraActions.getManagementRequestForm.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getManagementRequestForm.fulfilled,
      (state, action) => {
        state.ManagementForm = action.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getManagementRequestForm.rejected,
      (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to get Management Request form";
      }
    );
}
